import { Outlet } from '@tanstack/react-router';

/**
 * The outermost layout.
 *
 * Holds only what must wrap every route, signed in or not. Devtools are
 * imported lazily and only in development so they never reach a production
 * bundle.
 */
export function RootLayout() {
  return (
    <div className="min-h-dvh bg-surface-muted text-content">
      <Outlet />
    </div>
  );
}
